export function useUtilities() {
  var redirectTo = function redirectTo(url) {
    var newWindow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!url) return;
    newWindow ? window.open(url) : window.location.href = url;
  };
  return {
    redirectTo: redirectTo
  };
}